import Select from '../../../../../../components/textFields/AppSelect'
import { constraintConfig } from '../../../../../../constraintConfig'
import labelKey from '../../../../../localization/label.json'
import SelectField from '../../../../../../components/textFields/SelectField'
import TextField from '../../../../../../components/textFields/TextField'
import SearchSelect from '../../../../../../components/textFields/SearchSelect'
import { FaInfoCircle } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import React, { useMemo, useState, useRef, useEffect } from 'react'
import axios from 'axios'
import { baseUrl } from '../../../../../../services/baseUrl'
import clsx from 'clsx';
import ReactInputMask from 'react-input-mask';
import DateField from '../../../../../../components/textFields/DateField';
import { useGetAllTimeZoneQuery } from '../../../../../../services/UnauthApi';
import Swal from 'sweetalert2';

type Props = {
  formik: any
  departmentLookup: any
  designationLookup: any
  locationsData: any
  getAlldivision: any
  expenseTypeLookup?: any
  isTravelModuleAccessAvailable?: boolean
  /** When true, manager is the logged-in requester — hide lookup. */
  hideManagerLookup?: boolean
  /** Manager onboarding: Department and Designation are required. */
  requireDepartmentDesignation?: boolean
}
const Step1 = ({ formik,
  departmentLookup,
  designationLookup,
  locationsData,
  getAlldivision,
  expenseTypeLookup,
  isTravelModuleAccessAvailable = false,
  hideManagerLookup = false,
  requireDepartmentDesignation = false,
}: Props) => {
  const managers: any = []
  // State for searchable airport data
  const { data: timeZoneLookUp } = useGetAllTimeZoneQuery('')
  const [searchableManager, setSearchableManager] = useState([])
  const [isSearchingManager, setIsSearchingManager] = useState(false)
  useEffect(() => {
    // Initialize with all Manager
    if (managers.length > 0) {
      setSearchableManager(managers)
    }
  }, [managers])
  const searchManager = async (searchTerm: string) => {
    if (searchTerm.length < 2) {
      // If less than 2 characters, show all Manager
      setSearchableManager(managers)
      return
    }

    setIsSearchingManager(true)
    try {
      // Make API call to search Manager
      const response = await axios.get(
        `${baseUrl.MAIN_BASE_URL}/api/Account/GetAllManagersAndAdminsByString?srchString=${encodeURIComponent(searchTerm)}`,
        {
          headers: {
          },
        }
      )

      if (response.data && response.data.result) {
        setSearchableManager(response.data.result)
      }
    } catch (error) {
      console.error('Error searching Manager:', error)
    } finally {
      setIsSearchingManager(false)
    }
  }
  const showCorporateCardRequestConfirmation = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You are requesting a Corporate Credit card",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Request Corp Card',
      cancelButtonText: 'No, Cancel',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      }
    });

    return result.isConfirmed;
  };
  const showTravelPortalAccessConfirmation = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You need a Corporate Credit for this request.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Request Corp Card',
      cancelButtonText: 'No, Cancel',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      }
    });

    return result.isConfirmed;
  };
  return (
    <div className='current' data-kt-stepper-element='content'>
      <Tooltip id='tooltip' place='top' />
      <div className='w-100'>
        <div className='row fv-row'>
          {/* <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
            <label className='form-label fs-5 fw-bold required'>Requesting Account For</label>
            <Select
              isClearable={true}
              options={[
                ...([{ id: 1, value: 'Self' }, { id: 2, value: 'Other user' }]).map((option: any, index: any) => ({
                  value: option.id,
                  label: option?.value,
                })),
              ]}
              placeholder='Select Requesting For'
              value={
                formik.values.requestingAccountFor?.id
                  ? {
                    value: formik.values.requestingAccountFor?.id,
                    label: formik.values.requestingAccountFor?.value || '',
                  }
                  : ''
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue(`requestingAccountFor.id`, selectedOption?.value || null);
                formik.setFieldValue(`requestingAccountFor.value`, selectedOption?.label || null);
              }}
            />
          </div> */}

          <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
            <label className='form-label fs-5 fw-bold required'>Expense Account Type </label>
            <Select isClearable={true}
              options={[
                ...((expenseTypeLookup?.result?.length
                  ? expenseTypeLookup.result
                  : [{ id: 1, value: 'Flex' }, { id: 2, value: 'Regular' }, { id: 3, value: 'Both (Flex & Regular)' }]
                ).map((option: any) => ({
                  value: option.id,
                  label: option?.value,
                }))),
              ]}
              placeholder='Select Expense Account Type'
              value={
                formik.values.expenseType?.id
                  ? {
                    value: formik.values.expenseType?.id,
                    label: formik.values.expenseType?.value || '',
                  }
                  : null
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue(`expenseType.id`, selectedOption?.value || null);
                formik.setFieldValue(`expenseType.value`, selectedOption?.label || null);
              }}
            />
          </div>

          {/* Conditionally show the budget field */}
          {(
            // formik.values.requestingAccountFor?.id === 2 && // Other user (id: 2)
            (/flex/i.test(formik.values.expenseType?.value || '') ||
              formik.values.expenseType?.id === 2 || formik.values.expenseType?.id === 3)) && // Flex or Both
            <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
              <TextField
                label='User Flex Budget $'
                required={false}
                type='number'
                placeholder='Enter Flex Budget'
                {...formik.getFieldProps('flexBudget')}
              />
            </div>
          }
          <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
            <label className='form-label fs-5 fw-bold required'>User Type</label>
            <Select
              isClearable={true}
              options={[
                ...([{ id: 4, value: 'Manager' }, { id: 2, value: 'Provider' }, { id: 5, value: 'Employee' }]).map((option: any, index: any) => ({
                  value: option.id,
                  label: option?.value,
                })),
              ]}
              placeholder='Select User Type'
              value={
                formik.values.userType?.id
                  ? {
                    value: formik.values.userType?.id,
                    label: formik.values.userType?.value || '',
                  }
                  : null
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue(`userType.id`, selectedOption?.value || null);
                formik.setFieldValue(`userType.value`, selectedOption?.label || null);
              }}
            />
          </div>
          {!!isTravelModuleAccessAvailable && (
          <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
            <label className='form-label fs-5 fw-bold'>Request Travel Portal Access
            </label>
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer mt-3"
                type="checkbox"
                role="switch"
                id={`RequestTravelPortalAccess`}
                {...formik.getFieldProps('requestTravelPortalAccess')}
                checked={formik.values.requestTravelPortalAccess}
                onChange={async (e) => {
                  const newValue = e.target.checked;

                  // Only show confirmation when turning ON
                  if (newValue === true) {
                    // Prevent immediate change
                    if (!formik.values.requestCorporateCreditCard) {
                      e.preventDefault();
                      const confirmed = await showTravelPortalAccessConfirmation();
                      if (confirmed) {
                        formik.setFieldValue('requestTravelPortalAccess', true);
                        formik.setFieldValue('requestCorporateCreditCard', true);
                      } else {
                        // Do nothing - checkbox stays unchecked
                      }
                    } else {
                      // No confirmation needed for turning OFF - just update
                      formik.setFieldValue('requestTravelPortalAccess', true);
                    }
                  } else {
                    // No confirmation needed for turning OFF - just update
                    formik.setFieldValue('requestTravelPortalAccess', false);
                    formik.setFieldValue('requestCorporateCreditCard', false);
                  }
                }}
              />
            </div>
          </div>
          )}
          <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
            <label className='form-label fs-5 fw-bold'>Request Corporate Credit Card
              <FaInfoCircle className='ms-2'
                data-tooltip-id='tooltip'
                data-tooltip-content='Selecting this option to "Yes" while submitting your request will initiate required approvals.' />
            </label>
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer mt-3"
                type="checkbox"
                role="switch"
                id={`requestCorporateCreditCard`}
                {...formik.getFieldProps('requestCorporateCreditCard')}
                checked={formik.values.requestCorporateCreditCard}
                disabled={!!isTravelModuleAccessAvailable && formik.values.requestTravelPortalAccess}
                onChange={async (e) => {
                  const newValue = e.target.checked;
                  // Only show confirmation when turning ON
                  if (newValue === true) {
                    // Prevent immediate change
                    e.preventDefault();
                    const confirmed = await showCorporateCardRequestConfirmation();
                    if (confirmed) {
                      formik.setFieldValue('requestCorporateCreditCard', true);
                    } else {
                      // Do nothing - checkbox stays unchecked
                    }
                  } else {
                    // No confirmation needed for turning OFF - just update
                    formik.setFieldValue('requestCorporateCreditCard', false);
                    formik.setFieldValue('spendingLimit', 0);
                  }
                }}
              />
            </div>
          </div>
          {formik.values.requestCorporateCreditCard && (
            <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-5">
              <TextField
                label='Corp CC Limit'
                required={true}
                type='number'
                placeholder='Enter Corp CC Limit'
                {...formik.getFieldProps('spendingLimit')}
              />
            </div>
          )}
        </div>
        <div className='mb-5'>
          <div className='border-bottom border-gray-300 pb-5 mb-5'>
            <h3 className='text-gray-900 fw-bold fs-4'>Personal Details</h3>
          </div>
          <div>
            <div className='row fv-row'>
              <div className="row">
                <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-5">
                  <TextField
                    label={labelKey.email}
                    required={true}
                    type='email'
                    placeholder='Enter Email'
                    {...formik.getFieldProps('userName')}
                  />
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <TextField
                    label={labelKey.firstName}
                    required={true}
                    type='text'
                    placeholder='Enter First Name'
                    {...formik.getFieldProps('firstName')}
                  />

                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <TextField
                    label={labelKey.middleName}
                    type='text'
                    placeholder='Enter Middle Name'
                    {...formik.getFieldProps('middleName')}
                  />
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <div className='fv-row mb-5'>
                    <TextField
                      label={labelKey.lastName}
                      required={true}
                      type='text'
                      placeholder='Enter Last Name'
                      {...formik.getFieldProps('lastName')}
                    />
                  </div>
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <div className='fv-row mb-5'>
                    <label className='form-label fs-5 fw-bold'>{labelKey.cellPhone}</label>
                    <ReactInputMask
                      mask="999-999-9999"
                      placeholder='Cell Phone'
                      type='text'
                      autoComplete='off'
                      {...formik.getFieldProps('cellPhone')}
                      value={formik.values.cellPhone || ''}
                      className={clsx('form-control form-control-lg form-control-solid default-input')}
                    />
                  </div>
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <div className='fv-row mb-5'>
                    <label className='form-label fs-5 fw-bold'>{labelKey.businessPhone}</label>
                    <ReactInputMask
                      mask="999-999-9999"
                      placeholder='Business Phone'
                      type='text'
                      autoComplete='off'
                      {...formik.getFieldProps('businessPhone')}
                      value={formik.values.businessPhone || ''}
                      className={clsx('form-control form-control-lg form-control-solid default-input')}
                    />
                  </div>
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <div className='fv-row mb-5'>
                    <label className='form-label fs-5 fw-bold'>{labelKey.businessExt}</label>
                    <ReactInputMask
                      mask="9999"
                      placeholder='Business Ext'
                      type='text'
                      autoComplete='off'
                      {...formik.getFieldProps('businessExt')}
                      value={formik.values.businessExt || ''}
                      className='form-control form-control-lg form-control-solid default-input'
                    />
                  </div>
                </div>
                <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
                  <div className='fv-row mb-5'>
                    <SearchSelect
                      label={labelKey.timeZone}
                      required
                      options={[
                        { value: 0, label: 'Select Time Zone' },
                        ...(timeZoneLookUp?.result || []).map((option: any) => ({
                          value: option?.id,
                          label: option.value,
                          key: option.id,
                        }))]}
                      placeholder="Select Time Zone"
                      value={
                        formik.values?.userTimeZone?.id
                          ? {
                            value: formik.values?.userTimeZone?.id,
                            label: formik.values?.userTimeZone?.title || '',
                          }
                          : null
                      }
                      onChange={(selectedOption: any) => {
                        formik.setFieldValue('userTimeZone.id', selectedOption.value);
                        formik.setFieldValue('userTimeZone.title', selectedOption.label);
                      }}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-5">
                  <TextField
                    label='Dayforce ID'
                    required={true}
                    type='text'
                    placeholder='Enter Dayforce ID'
                    {...formik.getFieldProps('dayforceId')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='mb-5'>
          {/* Simple header */}
          <div className='border-bottom border-gray-300 pb-5 mb-5'>
            <h3 className='text-gray-900 fw-bold fs-4'>Office Details</h3>
          </div>
          <div className='row fv-row'>
            {!hideManagerLookup && (
            <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
              <label className={`form-label fs-5 fw-bold required`}>
                Manager Email
              </label>
              <InputSelect
                value={formik.values?.managerName}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('managerId', selectedOption?.value || 0);
                  formik.setFieldValue('managerName', selectedOption?.label || '');
                  // Label format from API is often "{id}-{email}" — extract email for persistence
                  const label = selectedOption?.label || '';
                  const emailFromLabel = label.includes('@')
                    ? (label.includes('-') && /^\d+-/.test(label) ? label.substring(label.indexOf('-') + 1) : label)
                    : '';
                  formik.setFieldValue('managerEmail', emailFromLabel || label || '');
                }}
                options={searchableManager}
                onSearch={searchManager}
                isLoading={isSearchingManager}
                placeholder='Type to search manager email'
                selectedValue={formik.values?.managerId || null}
              />
            </div>
            )}
            <div className='col-6 col-sm-6 col-md-4 col-lg-4 mb-5'>
              <label className='fs-5 fw-bold mb-2 required'>
                {formik.values.requestCorporateCreditCard ? 'Office Location' : labelKey.officeLocation}
              </label>
              <Select
                isClearable={true}
                placeholder='Select Location'
                options={(locationsData?.result || []).map((option: any, index: any) => ({
                  value: option.id,
                  label: option?.value,
                  key: option.id,
                }))}
                value={
                  formik.values.location?.id
                    ? {
                      value: formik.values.location?.id,
                      label: formik.values.location?.value || '',
                    }
                    : null
                }
                onChange={(selectedOption: any) => {
                  formik.setFieldValue(`location.id`, selectedOption?.value || null);
                  formik.setFieldValue(`location.value`, selectedOption?.label || null);
                }}
              />

            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-5">
              <label className='form-label fs-5 fw-bold required'>{labelKey.division}</label>
              <Select isClearable={true}
                options={[
                  ...(getAlldivision?.result || []).map((option: any, index: any) => ({
                    value: option.id,
                    label: option?.value,
                  })),
                ]}
                placeholder='Select Division'
                value={
                  formik.values.division?.id
                    ? {
                      value: formik.values.division?.id,
                      label: formik.values.division?.title || '',
                    }
                    : null
                }
                onChange={(selectedOption: any) => {
                  formik.setFieldValue(`division.id`, selectedOption?.value || null);
                  formik.setFieldValue(`division.title`, selectedOption?.label || null);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-5">
              <label className={`form-label fs-5 fw-bold${requireDepartmentDesignation ? ' required' : ''}`}>{labelKey.department}</label>
              <Select isClearable={true}
                options={[
                  ...(departmentLookup?.result || []).map((option: any, index: any) => ({
                    value: option.id,
                    label: option?.value,
                  })),
                ]}
                placeholder='Select Department'
                value={
                  formik.values.department?.id
                    ? {
                      value: formik.values.department?.id,
                      label: formik.values.department?.title || '',
                    }
                    : null
                }
                onChange={(selectedOption: any) => {
                  formik.setFieldValue(`department.id`, selectedOption?.value || null);
                  formik.setFieldValue(`department.title`, selectedOption?.label || null);
                }}
              />
            </div>
            <div className="col-6 col-sm-6 col-md-4 col-lg-4 mb-5">
              <label className={`form-label fs-5 fw-bold${requireDepartmentDesignation ? ' required' : ''}`}>{labelKey.designation}</label>
              <Select isClearable={true}
                options={[
                  ...(designationLookup?.result || []).map((option: any, index: any) => ({
                    value: option.id,
                    label: option?.value,
                  })),
                ]}
                placeholder='Select Designation'
                value={
                  formik.values.designation?.id
                    ? {
                      value: formik.values.designation?.id,
                      label: formik.values.designation?.title || '',
                    }
                    : null
                }
                onChange={(selectedOption: any) => {
                  formik.setFieldValue(`designation.id`, selectedOption?.value || null);
                  formik.setFieldValue(`designation.title`, selectedOption?.label || null);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export { Step1 }

function InputSelect({
  value,
  onChange,
  options,
  onSearch,
  isLoading = false,
  isInvalid = false,
  placeholder = 'Please type to search',
  selectedValue = null,
}: {
  value: string
  onChange: (v: any) => void // Changed to accept selectedOption object
  options: any
  onSearch?: (searchTerm: string) => void
  isLoading?: boolean
  isInvalid?: boolean,
  placeholder?: string,
  selectedValue?: any,
}) {
  const selectOptions =
    options?.map((o: any) => ({
      value: o.id,
      label: o.value,
    })) || []

  const selectedOption = selectOptions.find((option: any) =>
    String(option.value) === String(selectedValue != null ? selectedValue : value)
  ) || null

  // Debounce search to avoid too many API calls
  const debounceRef = useRef<NodeJS.Timeout>()

  const handleInputChange = (inputValue: string) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(() => {
      if (onSearch && inputValue.length >= 2) {
        onSearch(inputValue)
      }
    }, 300) // 300ms debounce
  }

  return (
    <Select
      options={selectOptions}
      placeholder={placeholder}
      value={selectedOption}
      onChange={(selected: any) => onChange(selected)}
      onInputChange={handleInputChange}
      isClearable={true}
      isLoading={isLoading}
      menuPortalTarget={document.body}
      noOptionsMessage={({ inputValue }) =>
        inputValue.length < 3 ? 'Type at least 3 characters to search' : 'No managers found'
      }
    />
  )
}
